import React from 'react'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

const Loading = () => {
  return (
    <Box>
      <Skeleton variant="rounded" width={'100%'} height={128} />
    </Box>
  )
}

Loading.displayName = 'Loading'

export default Loading
